import {useQuery} from "@tanstack/react-query";
import {readExchangeType1SelectBoxApi} from "../../../../../api/correspondent/CorresspondentApi";

/**
 * 환율 지정 조건 1 select hook
 * @param props
 * @returns
 */
export const useReadExchangeType1SelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readExchangeType1SelectBox"],
        queryFn: async () => await readExchangeType1SelectBoxApi(),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
